import React from "react";

export default function CopyStep11() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          11
        </div>
        <h1 className="font-semibold">
          Informe o valor depositado no passo anterior.
        </h1>
      </div>
      <div className="ml-[42px] flex flex-col gap-1.5">
        <p>
          Mantenha as opções <b>DESMARCADAS</b> conforme print.
        </p>
        <p>
          Por fim, <b>clique em "COPIAR"</b>.
        </p>
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/kpPrYs3449301.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
